module.exports = __webpack_public_path__ + "img/amocrm.5c3087d8.png";